'use strict';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/restrict-template-expressions, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call */
/**
 * This is a module that takes an original image and resizes
 * it to common icon sizes and will put them in a folder.
 * It will retain transparency and can make special file
 * types. You can control the settings.
 *
 * @module tauricon
 * @exports tauricon
 * @author Daniel Thompson-Yvetot
 * @license MIT
 */
var fs_extra_1 = require("fs-extra");
var imagemin_1 = __importDefault(require("imagemin"));
var imagemin_optipng_1 = __importDefault(require("imagemin-optipng"));
var imagemin_pngquant_1 = __importDefault(require("imagemin-pngquant"));
var imagemin_zopfli_1 = __importDefault(require("imagemin-zopfli"));
var is_png_1 = __importDefault(require("is-png"));
var path_1 = __importDefault(require("path"));
var png2icons = __importStar(require("png2icons"));
var read_chunk_1 = __importDefault(require("read-chunk"));
var sharp_1 = __importDefault(require("sharp"));
var app_paths_1 = require("../helpers/app-paths");
var logger_1 = __importDefault(require("../helpers/logger"));
var settings = __importStar(require("../helpers/tauricon.config"));
var chalk_1 = __importDefault(require("chalk"));
var package_json_1 = require("../../package.json");
var log = logger_1.default('app:spawn');
var warn = logger_1.default('app:spawn', chalk_1.default.red);
var image = false;
var spinnerInterval = false;
var exists = function (file) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fs_extra_1.access(file)];
                case 1:
                    _a.sent();
                    return [2 /*return*/, true];
                case 2:
                    err_1 = _a.sent();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
};
/**
 * This is the first call that attempts to memoize the sharp(src).
 * If the source image cannot be found or if it is not a png, it
 * is a failsafe that will exit or throw.
 *
 * @param {string} src - a folder to target
 * @exits {error} if not a png, if not an image
 */
var checkSrc = function (src) { return __awaiter(void 0, void 0, void 0, function () {
    var srcExists, buffer;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(image !== false)) return [3 /*break*/, 1];
                return [2 /*return*/, image];
            case 1: return [4 /*yield*/, exists(src)];
            case 2:
                srcExists = _a.sent();
                if (!!srcExists) return [3 /*break*/, 3];
                image = false;
                if (spinnerInterval)
                    clearInterval(spinnerInterval);
                warn('[ERROR] Source image for tauricon not found');
                process.exit(1);
                return [3 /*break*/, 5];
            case 3: return [4 /*yield*/, read_chunk_1.default(src, 0, 8)];
            case 4:
                buffer = _a.sent();
                if (is_png_1.default(buffer)) {
                    return [2 /*return*/, (image = sharp_1.default(src))];
                }
                else {
                    image = false;
                    if (spinnerInterval)
                        clearInterval(spinnerInterval);
                    warn('[ERROR] Source image for tauricon is not a png');
                    process.exit(1);
                }
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}); };
/**
 * Sort the folders in the current job for unique folders.
 *
 * @param {object} options - a subset of the settings
 * @returns {array} folders
 */
// TODO: proper type of options and folders
var uniqueFolders = function (options) {
    var folders = [];
    for (var type in options) {
        var option = options[String(type)];
        if (option.folder) {
            folders.push(option.folder);
        }
    }
    // TODO: is compare argument required?
    // eslint-disable-next-line @typescript-eslint/require-array-sort-compare
    folders = folders.sort().filter(function (x, i, a) { return !i || x !== a[i - 1]; });
    return folders;
};
/**
 * Turn a hex color (like #212342) into r,g,b values
 *
 * @param {string} hex - hex colour
 * @returns {array} r,g,b
 */
var hexToRgb = function (hex) {
    // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b;
    });
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16)
        }
        : undefined;
};
/**
 * validate image and directory
 */
var validate = function (src, target) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(target !== undefined)) return [3 /*break*/, 2];
                return [4 /*yield*/, fs_extra_1.ensureDir(target)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, checkSrc(src)];
            case 3:
                res = _a.sent();
                return [2 /*return*/, res];
        }
    });
}); };
// TODO: should take end param?
/**
 * Log progress in the command line
 *
 * @param {boolean} end
 */
var progress = function (msg) {
    process.stdout.write("  " + msg + "                       \r");
};
/**
 * Create a spinner on the command line
 *
 * @example
 *
 *     const spinnerInterval = spinner()
 *     // later
 *     clearInterval(spinnerInterval)
 */
var spinner = function () {
    return setInterval(function () {
        process.stdout.write('/ \r');
        setTimeout(function () {
            process.stdout.write('- \r');
            setTimeout(function () {
                process.stdout.write('\\ \r');
                setTimeout(function () {
                    process.stdout.write('| \r');
                }, 100);
            }, 100);
        }, 100);
    }, 500);
};
var tauricon = (exports.tauricon = {
    validate: function (src, target) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, validate(src, target)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, typeof image === 'object'];
                }
            });
        });
    },
    version: function () {
        return package_json_1.version;
    },
    make: function (src, target, strategy, 
    // TODO: proper type for options
    options) {
        if (src === void 0) { src = path_1.default.resolve(app_paths_1.appDir, 'app-icon.png'); }
        if (target === void 0) { target = path_1.default.resolve(app_paths_1.tauriDir, 'icons'); }
        return __awaiter(this, void 0, void 0, function () {
            var spinnerInterval;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerInterval = spinner();
                        options = options || settings.options.tauri;
                        return [4 /*yield*/, this.validate(src, target)];
                    case 1:
                        _a.sent();
                        progress('Building Tauri icns and ico');
                        return [4 /*yield*/, this.icns(src, target, options, strategy)];
                    case 2:
                        _a.sent();
                        progress('Building Tauri png icons');
                        return [4 /*yield*/, this.build(src, target, options)];
                    case 3:
                        _a.sent();
                        if (!strategy) return [3 /*break*/, 5];
                        progress("Minifying assets with " + strategy);
                        return [4 /*yield*/, this.minify(target, options, strategy, 'batch')];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        log('no minify strategy');
                        _a.label = 6;
                    case 6:
                        progress('Tauricon Finished');
                        clearInterval(spinnerInterval);
                        return [2 /*return*/, true];
                }
            });
        });
    },
    /**
     * Creates a set of images according to the subset of options it knows about.
     *
     * @param {string} src - image location
     * @param {string} target - where to drop the images
     * @param {object} options - js object that defines path and sizes
     */
    build: function (src, target, 
    // TODO: proper type for options
    options) {
        return __awaiter(this, void 0, void 0, function () {
            var sharpSrc, buildify2, output, folders, n, folder, _a, _b, _i, optionKey, option, _c, _d, _e, sizeKey, size, dest, pvar;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.validate(src, target)];
                    case 1:
                        _f.sent();
                        sharpSrc = sharp_1.default(src) // creates the image object
                        ;
                        buildify2 = function (pvar) {
                            return __awaiter(this, void 0, void 0, function () {
                                var pngImage, rgb, err_2;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            _a.trys.push([0, 2, , 3]);
                                            pngImage = sharpSrc.resize(pvar[1], pvar[1]);
                                            if (pvar[2]) {
                                                rgb = hexToRgb(options.background_color) || {
                                                    r: undefined,
                                                    g: undefined,
                                                    b: undefined
                                                };
                                                pngImage.flatten({
                                                    background: { r: rgb.r, g: rgb.g, b: rgb.b, alpha: 1 }
                                                });
                                            }
                                            pngImage.png();
                                            return [4 /*yield*/, pngImage.toFile(pvar[0])];
                                        case 1:
                                            _a.sent();
                                            return [3 /*break*/, 3];
                                        case 2:
                                            err_2 = _a.sent();
                                            warn(err_2);
                                            return [3 /*break*/, 3];
                                        case 3: return [2 /*return*/];
                                    }
                                });
                            });
                        };
                        folders = uniqueFolders(options);
                        // eslint-disable-next-line @typescript-eslint/no-for-in-array
                        for (n in folders) {
                            folder = folders[Number(n)];
                            // make the folders first
                            // TODO: should this be ensureDirSync?
                            // eslint-disable-next-line @typescript-eslint/no-floating-promises
                            fs_extra_1.ensureDir("" + target + path_1.default.sep + folder);
                        }
                        _a = [];
                        for (_b in options)
                            _a.push(_b);
                        _i = 0;
                        _f.label = 2;
                    case 2:
                        if (!(_i < _a.length)) return [3 /*break*/, 7];
                        optionKey = _a[_i];
                        option = options[String(optionKey)];
                        _c = [];
                        for (_d in option.sizes)
                            _c.push(_d);
                        _e = 0;
                        _f.label = 3;
                    case 3:
                        if (!(_e < _c.length)) return [3 /*break*/, 6];
                        sizeKey = _c[_e];
                        size = option.sizes[String(sizeKey)];
                        if (!!option.splash) return [3 /*break*/, 5];
                        dest = target + "/" + option.folder;
                        if (option.infix === true) {
                            output = "" + dest + path_1.default.sep + option.prefix + size + "x" + size + option.suffix;
                        }
                        else {
                            output = "" + dest + path_1.default.sep + option.prefix + option.suffix;
                        }
                        pvar = [
                            output,
                            size,
                            option.background
                        ];
                        return [4 /*yield*/, buildify2(pvar)];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5:
                        _e++;
                        return [3 /*break*/, 3];
                    case 6:
                        _i++;
                        return [3 /*break*/, 2];
                    case 7: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * Creates a set of splash images (COMING SOON!!!)
     *
     * @param {string} src - icon location
     * @param {string} splashSrc - splashscreen location
     * @param {string} target - where to drop the images
     * @param {object} options - js object that defines path and sizes
     */
    splash: function (src, splashSrc, target, 
    // TODO: proper type for options
    options) {
        return __awaiter(this, void 0, void 0, function () {
            var output, block, rgb, sharpSrc, data, _a, _b, _i, optionKey, option, _c, _d, _e, sizeKey, size, dest, pvar, sharpData;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        block = false;
                        rgb = hexToRgb(options.background_color) || {
                            r: undefined,
                            g: undefined,
                            b: undefined
                        };
                        if (splashSrc === src) {
                            // prevent overlay or pure
                            block = true;
                        }
                        if (!(block || options.splashscreen_type === 'generate')) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.validate(src, target)];
                    case 1:
                        _f.sent();
                        if (!image) {
                            process.exit(1);
                        }
                        sharpSrc = sharp_1.default(src);
                        sharpSrc
                            .extend({
                            top: 726,
                            bottom: 726,
                            left: 726,
                            right: 726,
                            background: {
                                r: rgb.r,
                                g: rgb.g,
                                b: rgb.b,
                                alpha: 1
                            }
                        })
                            .flatten({ background: { r: rgb.r, g: rgb.g, b: rgb.b, alpha: 1 } });
                        return [3 /*break*/, 3];
                    case 2:
                        if (options.splashscreen_type === 'overlay') {
                            sharpSrc = sharp_1.default(splashSrc)
                                .flatten({ background: { r: rgb.r, g: rgb.g, b: rgb.b, alpha: 1 } })
                                .composite([
                                {
                                    input: src
                                    // blend: 'multiply' <= future work, maybe just a gag
                                }
                            ]);
                        }
                        else if (options.splashscreen_type === 'pure') {
                            sharpSrc = sharp_1.default(splashSrc).flatten({
                                background: { r: rgb.r, g: rgb.g, b: rgb.b, alpha: 1 }
                            });
                        }
                        else {
                            throw new Error("unknown options.splashscreen_type: " + options.splashscreen_type);
                        }
                        _f.label = 3;
                    case 3: return [4 /*yield*/, sharpSrc.toBuffer()];
                    case 4:
                        data = _f.sent();
                        _a = [];
                        for (_b in options)
                            _a.push(_b);
                        _i = 0;
                        _f.label = 5;
                    case 5:
                        if (!(_i < _a.length)) return [3 /*break*/, 11];
                        optionKey = _a[_i];
                        option = options[String(optionKey)];
                        _c = [];
                        for (_d in option.sizes)
                            _c.push(_d);
                        _e = 0;
                        _f.label = 6;
                    case 6:
                        if (!(_e < _c.length)) return [3 /*break*/, 10];
                        sizeKey = _c[_e];
                        size = option.sizes[String(sizeKey)];
                        if (!option.splash) return [3 /*break*/, 9];
                        dest = "" + target + path_1.default.sep + option.folder;
                        return [4 /*yield*/, fs_extra_1.ensureDir(dest)];
                    case 7:
                        _f.sent();
                        if (option.infix === true) {
                            output = "" + dest + path_1.default.sep + option.prefix + size + "x" + size + option.suffix;
                        }
                        else {
                            output = "" + dest + path_1.default.sep + option.prefix + option.suffix;
                        }
                        pvar = [output, size];
                        sharpData = sharp_1.default(data);
                        sharpData = sharpData.resize(pvar[1][0], pvar[1][1]);
                        return [4 /*yield*/, sharpData.toFile(pvar[0])];
                    case 8:
                        _f.sent();
                        _f.label = 9;
                    case 9:
                        _e++;
                        return [3 /*break*/, 6];
                    case 10:
                        _i++;
                        return [3 /*break*/, 5];
                    case 11: return [2 /*return*/];
                }
            });
        });
    },
    /**
     * Minifies a set of images
     *
     * @param {string} target - image location
     * @param {object} options - where to drop the images
     * @param {string} strategy - which minify strategy to use
     * @param {string} mode - singlefile or batch
     */
    minify: function (target, 
    // TODO: proper type for options
    options, strategy, mode) {
        return __awaiter(this, void 0, void 0, function () {
            var cmd, minify, minifier, _a, folders, _b, _c, _i, n, folder;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        minify = settings.options.minify;
                        if (!minify.available.find(function (x) { return x === strategy; })) {
                            strategy = minify.type;
                        }
                        switch (strategy) {
                            case 'pngquant':
                                // TODO: is minify.pngquantOptions the proper format?
                                cmd = imagemin_pngquant_1.default(minify.pngquantOptions);
                                break;
                            case 'optipng':
                                cmd = imagemin_optipng_1.default(minify.optipngOptions);
                                break;
                            case 'zopfli':
                                cmd = imagemin_zopfli_1.default(minify.zopfliOptions);
                                break;
                            default:
                                throw new Error('unknown strategy' + strategy);
                        }
                        minifier = function (pvar, cmd) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, imagemin_1.default([pvar[0]], {
                                            destination: pvar[1],
                                            plugins: [cmd]
                                        }).catch(function (err) {
                                            warn(err);
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        _a = mode;
                        switch (_a) {
                            case 'singlefile': return [3 /*break*/, 1];
                            case 'batch': return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 8];
                    case 1: return [4 /*yield*/, minifier([target, path_1.default.dirname(target)], cmd)];
                    case 2:
                        _d.sent();
                        return [3 /*break*/, 9];
                    case 3:
                        folders = uniqueFolders(options);
                        _b = [];
                        for (_c in folders)
                            _b.push(_c);
                        _i = 0;
                        _d.label = 4;
                    case 4:
                        if (!(_i < _b.length)) return [3 /*break*/, 7];
                        n = _b[_i];
                        folder = folders[Number(n)];
                        log('batch minify:' + String(folder));
                        return [4 /*yield*/, minifier([
                                "" + target + path_1.default.sep + folder + path_1.default.sep + "*.png",
                                "" + target + path_1.default.sep + folder
                            ], cmd)];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        _i++;
                        return [3 /*break*/, 4];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        warn('[ERROR] Minify mode must be one of [ singlefile | batch]');
                        process.exit(1);
                        _d.label = 9;
                    case 9: return [2 /*return*/, 'minified'];
                }
            });
        });
    },
    /**
     * Creates special icns and ico filetypes
     *
     * @param {string} src - image location
     * @param {string} target - where to drop the images
     * @param {object} options
     * @param {string} strategy
     */
    icns: function (src, target, 
    // TODO: proper type for options
    options, strategy) {
        return __awaiter(this, void 0, void 0, function () {
            var sharpSrc, buf, out, out2, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!image) {
                            process.exit(1);
                        }
                        return [4 /*yield*/, this.validate(src, target)];
                    case 1:
                        _a.sent();
                        sharpSrc = sharp_1.default(src);
                        return [4 /*yield*/, sharpSrc.toBuffer()];
                    case 2:
                        buf = _a.sent();
                        out = png2icons.createICNS(buf, png2icons.BICUBIC, 0);
                        if (out === null) {
                            throw new Error('Failed to create icon.icns');
                        }
                        fs_extra_1.ensureFileSync(path_1.default.join(target, '/icon.icns'));
                        fs_extra_1.writeFileSync(path_1.default.join(target, '/icon.icns'), out);
                        out2 = png2icons.createICO(buf, png2icons.BICUBIC, 0, true);
                        if (out2 === null) {
                            throw new Error('Failed to create icon.ico');
                        }
                        fs_extra_1.ensureFileSync(path_1.default.join(target, '/icon.ico'));
                        fs_extra_1.writeFileSync(path_1.default.join(target, '/icon.ico'), out2);
                        return [3 /*break*/, 4];
                    case 3:
                        err_3 = _a.sent();
                        console.error(err_3);
                        throw err_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
});
/* eslint-enable @typescript-eslint/restrict-template-expressions */
if (typeof exports !== 'undefined') {
    if (typeof module !== 'undefined' && module.exports) {
        exports = module.exports = tauricon;
    }
    exports.tauricon = tauricon;
}
